// 数据看板页面翻译
export default {
  // 按钮
  buttons: {
    viewDetails: "看板详情",
  },

  // 标签页
  tabs: {
    balanceBoard: "余额看板",
    transactionBoard: "交易看板",
  },

  // 提示信息
  messages: {
    noData: "暂无数据",
  },
};
